<template>
  <div class="">
    <div class="flex items-center justify-center bg-[#fffaf0]">
      <button @click="goToPropertySelection" class="w-[80px] h-[80px]">
        <img
          src="/icons/user.png"
          alt="account"
          class="w-[80px] h-[60px] bg-[#fffaf0]"
        />
      </button>
      <div class="w-full bg-[#fffaf0] py-4 pl-2">
        <div class="text-xs">
          {{ buyer_name }}
        </div>
        <div v-if="contract_status !== 'INACTIVE'">
          <div class="text-xs">{{ project }}</div>
          <div class="text-xs">
            Ph: {{ phase }} Blk:{{ block }} Lt: {{ lot }}
          </div>
        </div>
      </div>
    </div>
    <!-- sidebar  -->
    <div class="hidden sm:block">
      <div
        v-for="(item, i) in sidebar"
        :key="i"
        class="
          md:border-r md:border-gray-500
          w-full
          bg-gray-200
          md:bg-[#E5EBF7]
          my-2
          md:my-0
        "
      >
        <div class="md:hidden mb-4"></div>
        <v-btn
          text
          v-if="
            (item.sidebar_title !== 'Statement of Account' ||
              contract_status !== 'INACTIVE') &&
              (item.sidebar_title !== 'My Documents' ||
                contract_status !== 'INACTIVE') &&
              item.sidebar_id != 11 &&
              item.sidebar_id != 12 &&
              item.sidebar_id != 21 &&
              item.sidebar_id != 22 &&
              item.sidebar_id != 26 &&
              item.sidebar_id != 23
          "
          @click="sidebar_to(item)"
          class="py-4 w-full flex justify-start"
          small
        >
          <div class="mr-2">
            <!-- <v-icon> mdi-{{ item.icon }} </v-icon> -->
          </div>
          <div class="text-left md:text-sm text-xs md:block">
            {{ item.sidebar_title }}
            <!-- {{ item.sidebar_id }} -->
          </div>
        </v-btn>

        <v-btn
          text
          v-else
          disabled
          class="py-4 w-full flex justify-start"
          small
        >
          <div class="mr-2">
            <!-- <v-icon> mdi-{{ item.icon }} </v-icon> -->
          </div>
          <div class="text-left md:text-sm text-xs md:block hidden">
            {{ item.sidebar_title }}
          </div>
        </v-btn>

        <div class="md:hidden mb-4"></div>
      </div>
    </div>

    <!-- if mobile  -->
    <div class="block sm:hidden pr-2">
      <div
        v-for="(item, i) in sidebar"
        :key="i"
        class="
         md:border-gray-500
          w-full
          bg-gray-200
          md:bg-[#E5EBF7]
          my-1
          md:my-0
        "
      >
        <div class="md:hidden"></div>
        <v-btn
          text
          v-if="
            (item.sidebar_title !== 'My Documents' ||
              contract_status !== 'INACTIVE') &&
              item.sidebar_id != 11 &&
              item.sidebar_id != 12 &&
              item.sidebar_id != 21 &&
              item.sidebar_id != 22 &&
              item.sidebar_id != 26 &&
              item.sidebar_id != 23
          "
          @click="sidebar_to(item)"
          class="py-4 w-full flex justify-start"
          small
        >
          <div class="mr-2">
            <!-- <v-icon> mdi-{{ item.icon }} </v-icon> -->
          </div>
          <div class="text-left md:text-sm text-xs md:block">
            {{ item.sidebar_title }}
            <!-- {{ item.sidebar_id }} -->
          </div>
        </v-btn>
      </div>
    </div>
    <v-snackbar v-model="snackbar" top>
      {{ snackbarText }}
      <v-btn text @click.native="value = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import SecureStorage from "../utils/secureStorage";
export default {
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      customerCode: "",
      sidebar: [],
      email: "",
      contract_number: "",
      buyer_name: "",
      property: "",
      project: "",
      phase: "",
      block: "",
      lot: "",
      contract_status: "", // Added contract_status here
    };
  },
  mounted() {
    this.populate_sidebar();
  },
  watch: {
    "$route.path": {
      handler() {
        const auth = SecureStorage.getItem("auth") || {};
        this.contract_number = auth.contract_number;
        this.property = auth.property;
        this.buyer_name = auth.buyerName;
        this.phase = auth.phase;
        this.block = auth.block;
        this.lot = auth.lot;
        this.project = auth.project;
        this.contract_status = auth.contract_status;
      },
      immediate: true,
    },
  },
  methods: {
    clearLocalStorage() {
      SecureStorage.removeItem("contract_number");
      SecureStorage.removeItem("property");
      SecureStorage.removeItem("project");
      SecureStorage.removeItem("phase");
      SecureStorage.removeItem("block");
      SecureStorage.removeItem("lot");
      SecureStorage.removeItem("contract_status");
    },
    goToPropertySelection() {
      this.clearLocalStorage(); // Clear localStorage when navigating to Property Selection
      this.$router.push({
        name: "Property Selection",
        query: {
          cc: this.$route.query.cc,
        },
      });
    },
    sidebar_to(item) {
      if (item.path == "dashboard") {
        const role = SecureStorage.getItem("auth")?.role;
        if (role === "client") {
          if (!this.$route.path.includes("customer-dashboard")) {
            this.$router.push({
              name: "Customer Dashboard",
              query: {
                cc: this.$route.query.cc,
                cn: this.$route.query.cn,
              },
            });
          }
        } else {
          if (!this.$route.path.includes("admin-dashboard")) {
            this.$router.push("/home/admin-dashboard");
          }
        }
      } else if (item.path == "statement-of-account") {
        if (!this.$route.path.includes(item.path)) {
          this.$router.push({
            name: "Statement of Account",
            query: {
              cc: this.$route.query.cc,
              cn: this.$route.query.cn,
            },
          });
        }
      } else if (item.path == "payment-schedule") {
        if (!this.$route.path.includes(item.path)) {
          this.snackbarText = "Under construction";
          this.snackbar = true;
        }
      } else if (item.path == "title-transfer") {
        if (!this.$route.path.includes(item.path)) {
          this.snackbarText = "Under construction";
          this.snackbar = true;
        }
      } else if (item.path == "loan-application") {
        if (!this.$route.path.includes(item.path)) {
          this.snackbarText = "Under construction";
          this.snackbar = true;
        }
      } else if (item.path == "house-construction") {
        if (!this.$route.path.includes(item.path)) {
          this.snackbarText = "Under construction";
          this.snackbar = true;
        }
      } else if (item.path == "move-in") {
        if (!this.$route.path.includes(item.path)) {
          this.snackbarText = "Under construction";
          this.snackbar = true;
        }
      } else if (item.path == "my-documents") {
        if (!this.$route.path.includes(item.path)) {
          this.$router.push({
            name: "My Documents",
            query: {
              cc: this.$route.query.cc,
              cn: this.$route.query.cn,
            },
          });
        }
      } else if (item.path == "book_appointment") {
        if (!this.$route.path.includes(item.path)) {
          this.$router.push({
            name: "Book an Appointment",
            query: {
              cn: this.$route.query.cn,
              cc: this.$route.query.cc,
            },
          });
        }
      }
    },
    populate_sidebar() {
      const role = SecureStorage.getItem("auth")?.role;

      let data = {
        role_id: role === "client" ? 2 : 1, // 1 for client, 2 for admin/other
      };

      axios.post("/menu/sidebar", data).then((res) => {
        this.sidebar = res.data;
      });
    },
  },
};
</script>
